'use strict';

angular.module('app.entity.audit').component('historyFieldDicomValue', {
    templateUrl: 'modules/ecrd/components/audit/components/history-field-dicom-value.template.html',
    bindings: {
        value: '<',
    },
    controller: [function() {
        var vm = this;
    }],
});
